import { render, staticRenderFns } from "./businessApproval.vue?vue&type=template&id=5ca95f70&scoped=true"
import script from "./businessApproval.vue?vue&type=script&lang=js"
export * from "./businessApproval.vue?vue&type=script&lang=js"
import style0 from "./businessApproval.vue?vue&type=style&index=0&id=5ca95f70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca95f70",
  null
  
)

export default component.exports